import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isActiveApplication: false,
    currentApplication: null,
}

const applicationSlice = createSlice({
    name: 'application',
    initialState,
    reducers: {
        fetchingApplicationSuccess: (state, action) => {
            state.isActiveApplication = true;
            state.currentApplication = action.payload;
        },
        fetchingApplicationReset: (state) => {
            state.isActiveApplication = false;
            state.currentApplication = null;
        },
    }
});

export const { fetchingApplicationSuccess, fetchingApplicationReset } = applicationSlice.actions;

export default applicationSlice.reducer;